module.exports = function getResource(label, vars = []) {
    let resources = {
        viewSimilarProducts: 'View similar products'
    };

    return resources[label];
};
